var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalStaked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.05,
    cy: 47.43,
    rx: 42.8,
    ry: 15.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.74,59.87c-6,6.28-22.83,10.8-42.69,10.8S32.47,66.18,26.42,59.94V74.49C28.31,82.6,46.67,89,69.05,89c22.67,0,41.21-6.53,42.69-14.78Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.74,86.35c-6,6.28-22.83,10.81-42.69,10.81s-36.58-4.5-42.63-10.74V101c1.89,8.1,20.25,14.47,42.63,14.47,22.67,0,41.21-6.53,42.69-14.79Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131,63.28a112.32,112.32,0,0,0-11.54.59V94.38A112.32,112.32,0,0,0,131,95c23.64,0,42.8-7.09,42.8-15.84S154.59,63.28,131,63.28Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131,102.37c-4,0-7.86-.19-11.54-.53v18.23a112.32,112.32,0,0,0,11.54.59c22.68,0,41.22-6.53,42.69-14.79V91.56C167.66,97.84,150.81,102.37,131,102.37Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131,128.85c-4,0-7.86-.18-11.54-.53v18.23a112.32,112.32,0,0,0,11.54.59c22.68,0,41.22-6.53,42.69-14.79v-14.3C167.66,124.33,150.81,128.85,131,128.85Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.74,112.84c-6,6.28-22.83,10.8-42.69,10.8s-36.58-4.49-42.63-10.74v14.56c1.89,8.11,20.25,14.47,42.63,14.47,22.67,0,41.21-6.53,42.69-14.79Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.74,139.32c-6,6.28-22.83,10.81-42.69,10.81s-36.58-4.5-42.63-10.74V154c1.89,8.1,20.25,14.46,42.63,14.46,22.67,0,41.21-6.53,42.69-14.78Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalStaked);
export default __webpack_public_path__ + "static/media/totalStaked.9bb3148c.svg";
export { ForwardRef as ReactComponent };